<template>
  <router-view />
</template>
<script>
export default {
  created() {
    this.$router.afterEach((to) => {
      document.title = "Timetracker · " + this.$t(to.meta.title) || "Timetracker";
    });
  },
};
</script>
